import { render, staticRenderFns } from "./SecurityList.vue?vue&type=template&id=3b716439&"
import script from "./SecurityList.vue?vue&type=script&lang=js&"
export * from "./SecurityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b716439')) {
      api.createRecord('3b716439', component.options)
    } else {
      api.reload('3b716439', component.options)
    }
    module.hot.accept("./SecurityList.vue?vue&type=template&id=3b716439&", function () {
      api.rerender('3b716439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/SecurityList.vue"
export default component.exports